import { render, staticRenderFns } from "./CheckboxGroup.vue?vue&type=template&id=2dc3c7d2"
import script from "./CheckboxGroup.vue?vue&type=script&lang=js"
export * from "./CheckboxGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_css-loader@3.6.0_webpack@4.47.0__ejs@3.1.10_be517b630ad34e2df4a68e8854480672/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports